import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  ViewChild,
  OnInit,
  inject
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalService } from '@shared/services/modal.service';
import { tap } from 'rxjs';
import { ThemeService } from '../services/theme.service';
import { ModalPersonalDataInfoComponent } from './modal-personal-data-info/modal-personal-data-info.component';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisterComponent implements OnInit {
  private _destroyRef = inject(DestroyRef);
  private _cdr = inject(ChangeDetectorRef);
  @ViewChild('fileInput') fileInput: ElementRef = {} as ElementRef;
  user = {
    name: '',
    last_name: '',
    role: '',
    phone: '',
    email: '',
    password: '',
    confirm_password: '',
    privacy: false,
    img: ''
  };
  userImage: string | ArrayBuffer | null = 'https://xsgames.co/randomusers/avatar.php?g=male';
  validInputs: Record<string, boolean> = {};

  isLight = true;

  form!: FormGroup;

  constructor(
    public translateService: TranslateService,
    private router: Router,
    private modalService: ModalService,
    private themeService: ThemeService,
    private formBuilder: FormBuilder
  ) {
    this.form = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      role: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', Validators.required],
      password: ['', Validators.required],
      confirm_password: ['', Validators.required],
      privacy: ['', Validators.required],
      img: ['']
    });
  }

  ngOnInit() {
    this.themeService.isLight$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap((x) => (this.isLight = x))
      )
      .subscribe(() => this._cdr.markForCheck());
  }

  onSubmit() {
    if (this.form.valid) {
      this.router.navigate(['/registration-complete']);
    }
  }

  triggerFileUpload() {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const element = event.currentTarget as HTMLInputElement;
    const file: File | null = element.files ? element.files[0] : null;

    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.userImage = reader.result as string;
        this.user.img = this.userImage;
        this._cdr.markForCheck();
      };
      reader.readAsDataURL(file);
    }
  }

  getYear() {
    return new Date().getFullYear();
  }

  onOpenModalInfo(event: Event) {
    event.stopPropagation();
    this.modalService.open(ModalPersonalDataInfoComponent);
  }
}
